import React from "react";
import PropTypes from "prop-types";
import { withStyles, Typography } from "@material-ui/core";
import { themeTypeToBool } from '../../../../utils/helpers';

const useStyles = theme => ({
    detailsRow: {
        display: "flex",
        alignItems: "center",
        justifyContent: "flex-start"
    },
    detailText: {
        color: themeTypeToBool(theme.palette.type) ? theme.palette.common.black : theme.palette.common.white
    },
    descriptionText: {
        color: themeTypeToBool(theme.palette.type) ? theme.palette.secondary : "#bebed3"
    }
});

const DescriptionDetail = props => {
    const { classes, title, value } = props;

    return (
        <div className={classes.detailsRow}>
            <Typography variant="body2" color="secondary" classes={{colorSecondary: classes.descriptionText}}>
                {title}:&nbsp;
                </Typography>
            <Typography variant="body1" className={classes.detailText}>{value}</Typography>
        </div>
    );
};

export default withStyles(useStyles)(DescriptionDetail);

DescriptionDetail.propTypes = {
    classes: PropTypes.object,
    title: PropTypes.string,
    value: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
};